import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerWithTimeComponent from "../DatePickerWithTimeComponent";
import { useAuth } from "../../contexts/AuthContext";
import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { showCustomToast } from "../Misc/CustomToast";
import UploaderDocForNote from "../Updloader/UploaderDocForNote";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

import Chip from "@mui/material/Chip";

function AddMedicalNote(props) {

  const { currentUser } = useAuth();

  // useEffect(() => {
  //   recordMetrics("Notes", "medicalNotes", currentUser.email, "write", "bodhi");
  // }, []);

  //Tous les states des données récupérées par client

  const [isLoading, setIsLoading] = useState(false);

  const [medicalNote, setMedicalNote] = useState("");
  const [medicalNoteDateTime, setMedicalNoteDateTime] = useState(new Date());
  const [files, setFiles] = useState([]);
  const draftKey = `draft:medicalNote:${currentUser?.uid || "anon"}:${
    props.clientId || "unknown"
  }`;
  const draftDelay = 800;
  const [isSavingDraft, setIsSavingDraft] = useState(false);

  const handleMedicalNoteChange = (event) => {
    setMedicalNote(event.target.value);
  };

  const handleDateTimeChange = (event) => {
    setMedicalNoteDateTime(event);
  };

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files.length <= 10) {
      setFiles(event.target.files);
    } else {
      showCustomToast("You can only upload up to 10 files.", "error");
    }
  };

  // Restore draft on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(draftKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.text) setMedicalNote(parsed.text);
        if (parsed?.date) {
          const d = new Date(parsed.date);
          if (!isNaN(d)) setMedicalNoteDateTime(d);
        }
      }
    } catch (e) {
      console.warn("MedicalNote draft load error:", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Autosave draft with debounce
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        localStorage.setItem(
          draftKey,
          JSON.stringify({
            text: medicalNote,
            date: medicalNoteDateTime?.toISOString?.() || null,
          })
        );
        setIsSavingDraft(false);
      } catch (e) {
        console.warn("MedicalNote draft save error:", e);
      }
    }, draftDelay);
    setIsSavingDraft(true);
    return () => clearTimeout(t);
  }, [medicalNote, medicalNoteDateTime, draftKey]);

  const uploadFilesAndGetUrls = async (docId) => {
    const storage = getStorage();
    const fileUrls = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const filePath = `Documents/medicalNotes/${docId}/${file.name}`;
      const storageRef = ref(storage, filePath);

      await uploadBytes(storageRef, file);
      const fileUrl = await getDownloadURL(storageRef);
      fileUrls.push({ url: fileUrl, name: file.name });
    }

    return fileUrls;
  };

  const handleAddMedicalNote = async (note, clientID, effectiveDateTime) => {
    const noteData = {
      noteType: "medicalNote",
      noteContent: note,
      clientId: clientID,
      createdAt: serverTimestamp(),
      effectiveDateTime: effectiveDateTime,
      doneBy: currentUser.displayName,
      clientFirstName: props.firstName,
      clientLastName: props.lastName,
      clientProfilePicture: props.profilePicture || "",
    };

    if (medicalNote && medicalNoteDateTime) {
      setIsLoading(true);
      try {
        const docRef = await addDoc(collection(db, "notes"), noteData);
        const fileUrls = await uploadFilesAndGetUrls(docRef.id);
        await updateDoc(doc(db, "notes", docRef.id), {
          fileUrls: fileUrls,
        });
        showCustomToast(`Medical note successfully added!`, "success");
        setIsLoading(false);
        try {
          localStorage.removeItem(draftKey);
        } catch {}
        props.closemodal();
      } catch (error) {
        console.log("error adding note :", error);
        showCustomToast(`Problem when adding note`, "error");
      }
    } else {
      showCustomToast(
        `Some mandatory fields are empty. Please check.`,
        "error"
      );
    }
  };

  const handleSubmit = () => {
    handleAddMedicalNote(medicalNote, props.clientId, medicalNoteDateTime);
  };

  return (
    <>
      <div
        className="inputAndLabelModalContainerTitle2"
        style={{ width: "auto", height: "100%" }}
      >
        <div className="line1-modal-percent">
          <div className="modal-title" style={{ paddingLeft: "10px" }}>
            Add medical note
          </div>
          <CloseIcon
            style={{
              marginRight: "16px",
              color: "rgb(214, 213, 213)",
              cursor: "pointer",
            }}
            onClick={props.closemodal}
          />
        </div>

        <div
          // style={{ marginTop: "60px", height: "550px", overflowY: "scroll" }}
          style={{
            width: "100%",
            marginTop: "10px",
            height: "75%",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <div
            className="line2-column-modal"
            style={{
              paddingLeft: "10px",
              // backgroundColor: "pink",
            }}
          >
            <div
              className="label-textfield"
              style={{ paddingLeft: "15px", paddingBottom: "5px" }}
            >
              Note content
            </div>
            <TextField
              value={medicalNote}
              onChange={handleMedicalNoteChange}
              style={{
                width: "95%",
                borderRadius: "5px",
                backgroundColor: "#f2eeef",
              }}
              placeholder="Type medical note here"
              multiline
              rows={14}
            />
          </div>
          <div
            className="line3-modal-nopad"
            style={{
              marginLeft: "30px",
              paddingTop: "10px",
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <DatePickerWithTimeComponent
              title="Effective date and time"
              value={medicalNoteDateTime}
              onChange={handleDateTimeChange}
            />
          </div>

          <UploaderDocForNote
            handleFileChange={handleFileChange}
            files={files}
          />
        </div>
        <div
          className="line4-modal-percent"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <Chip
            label={
              isSavingDraft
                ? "Saving draft..."
                : medicalNote
                ? "Draft saved"
                : "No draft"
            }
            size="small"
            sx={{
              backgroundColor: isSavingDraft
                ? "#f9a825"
                : medicalNote
                ? "#2e7d32"
                : "#607d8b",
              color: "#fff",
              fontWeight: 700,
            }}
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              try {
                localStorage.removeItem(draftKey);
              } catch {}
              setMedicalNote("");
              setMedicalNoteDateTime(new Date());
            }}
          >
            Clear draft
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "white", color: "black" }}
            onClick={props.closemodal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={
              isLoading
                ? {
                    backgroundColor: "red",
                    color: "white",
                    marginLeft: "15px",
                  }
                : {
                    backgroundColor: "#1565C0",
                    color: "white",
                    marginLeft: "15px",
                  }
            }
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "SUBMITTING..." : "SUBMIT"}
          </Button>
        </div>
      </div>
    </>
  );
}

export default AddMedicalNote;
